import React, { ReactNode } from "react"

//Styles
import Styles from "./Switch.module.scss"
import classnames from "classnames"

interface SwitchProps{
    isChecked:boolean;
    onChange:()=>void;
    name:string;
    icon?:ReactNode;
    isDisabled?:boolean
    showLabel?:boolean;
}

const Switch = ({isChecked,onChange,name,icon,isDisabled,showLabel=true}:SwitchProps) => {
  return (
    < div className={Styles.switch_container} onClick={onChange}>
        <div className={isChecked?Styles.active_icon:Styles.icon}>
        {icon}</div>
      <input
        className={Styles.switch}
        id={name}
        type="checkbox"
        checked={isChecked}
        disabled={isDisabled}
        onChange={()=>{}}
      />
      {
        showLabel && (
          <label
            className={isChecked?Styles.active_label:Styles.label}
            htmlFor={`react-switch-new`}
          >
            <span className={isChecked?Styles.enabled_switch_button:Styles.switch_button} />
          </label>)
      }
      {isDisabled
      && <div className={Styles.disabledSwitch}/>}
      
    </div>
  )
}

export default Switch
